<template>
  <div
    class="select-ids-panel"
    v-byted-loading="isLoading"
    data-no-translate
  >
    <byted-select-panel
      class="select-panel-search-result"
      list-width="198px"
      v-model="selectedIds"
      v-byted-loading="isSearchLoading"
      :title="panelTitle"
      :options="filteredOptionList"
      :async="true"
      :auto-scroll="true"
      :has-check-all="false"
      :show-seleted-moduler="false"
    ></byted-select-panel>
    <byted-select-panel
      class="select-panel"
      list-width="198px"
      v-model="selectedIds"
      :title="panelTitle"
      :options="optionList"
      :async="true"
      :auto-scroll="true"
    ></byted-select-panel>
  </div>
</template>

<script>
const filterOptions = searchInput => option => { return (option.originId.toString().includes(searchInput)) || (option.name.includes(searchInput)) }

export default {
  name: 'select-panel-filterable',
  props: {
    value: {
      tyep: Array,
      default: () => []
    },
    panelTitle: {
      type: Array,
      default: () => ['选择']
    },
    optionList: {
      type: Array,
      default: () => []
    },
    searchInput: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filteredOptionList: this.optionList,
      isSearchLoading: false
    }
  },
  computed: {
    selectedIds: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  },
  watch: {
    searchInput () {
      this.setFilteredOptionList()
    },
    optionList (val) {
      this.filteredOptionList = val
    }
  },
  methods: {
    clearSelected () {
      this.selectedIds = []
    },
    setFilteredOptionList: _.debounce(function () {
      this.isSearchLoading = true
      this.$nextTick(() => {
        if (this.searchInput?.length > 0) {
          this.filteredOptionList = this.optionList.filter(filterOptions(this.searchInput))
        } else {
          this.filteredOptionList = this.optionList
        }
        this.isSearchLoading = false
      })
    })
  }
}
</script>

<style lang="scss" scoped>
@import "src/basic/theme.scss";

.select-panel {
  /deep/.bui-select-panel-left {
    display: none;
  }
}

.select-panel-search-result {
  width: calc(100% - 214px);
  margin-right: 16px;
}
</style>
